import houseApi from "@/api/houseApi"
import addressApi from "@/api/addressApi"
import UseSearchString from "@/composables/UseSearchString"

export default {
  namespaced: true,
  state: {
    houseForm: {
      id: undefined,
      year: undefined,
      kadastr: undefined,
      house: {
        address: undefined,
        fias: undefined,
        id: undefined,
        lat: undefined,
        links: undefined,
        lon: undefined,
        name: undefined,
        zip_code: undefined
      }
    },
    houseFormErrors: {
      pageNotFound: false
    },
    variantsList: [],
    variantsQuery: '',
    address: {
      sign: '',
      addressAfterClick: '',
      hasHouseInAddress: false
    },
    isSubmitLoading: false,
    isDeleteHouseLoading: false,
    isVariantsListLoading: false

  },
  getters: {
    hasHouseData: state => (
      state.houseForm.house.address &&
      state.houseForm.house.fias &&
      state.houseForm.house.id &&
      state.houseForm.house.lat &&
      state.houseForm.house.lon &&
      state.houseForm.house.links &&
      state.houseForm.house.name &&
      state.houseForm.house.zip_code
    ),
    getVariantsList: state => {
      const stringToFill = state.variantsQuery.replace(state.address.addressAfterClick, '').trim()
      return state.variantsList.map(i => ({
        ...i,
        valueMarked: UseSearchString.fillSearchResult(i.value.split(',').reverse().join(', '), stringToFill)
      }))
    }
  },
  mutations: {
    setHouseFormErrors(state, payload) {
      state.houseFormErrors = {
        ...state.houseFormErrors,
        ...payload
      }
    },
    setFormYear(state, payload) {
      state.houseForm.year = payload
    },
    setFormKadastr(state, payload) {
      state.houseForm.kadastr = payload
    },
    setHouseId(state, payload) {
      state.houseForm.id = payload
    },
    setHouseData(state, payload) {
      state.houseForm = {
        ...state.houseForm,
        ...payload,
        house: {
          ...state.houseForm.house,
          ...payload.house
        }
      }
    },
    setVariantsList(state, {suggestions, query}) {
      state.variantsList = suggestions
      state.variantsQuery = query
    },
    setAddress(state, {value, sign}) {
      state.address.sign = sign
      state.houseForm.house.address = state.address.addressAfterClick = value
    },
    setAddressValue(state, payload) {
      state.houseForm.house.address = payload
      state.address.hasHouseInAddress = false
    },
    setHouseInAddressExists(state, payload) {
      state.address.hasHouseInAddress = payload
    },
    clearHousePassportData(state) {
      state.houseForm = {
        id: undefined,
        kadastr: undefined,
        year: undefined,
        house: {
          address: undefined,
          fias: undefined,
          id: undefined,
          lat: undefined,
          links: undefined,
          lon: undefined,
          name: undefined,
          zip_code: undefined
        }
      }
      state.variantsList = []
      state.address.hasHouseInAddress = false
    },
    clearHouseData(state) {
      state.houseForm.house = {
        address: undefined,
        fias: undefined,
        id: undefined,
        lat: undefined,
        links: undefined,
        lon: undefined,
        name: undefined,
        zip_code: undefined
      }
      state.variantsList = []
      state.address.hasHouseInAddress = false
    },
    clearHouseDataWithoutAddress(state) {
      state.houseForm.house = {
        ...state.houseForm.house,
        fias: undefined,
        id: undefined,
        lat: undefined,
        links: undefined,
        lon: undefined,
        name: undefined,
        zip_code: undefined
      }
      state.variantsList = []
      state.address.hasHouseInAddress = false
    },
    setSubmitLoading(state, payload) {
      state.isSubmitLoading = payload
    },
    setDeleteHouseLoading(state, payload) {
      state.isDeleteHouseLoading = payload
    },
    setVariantsListLoading(state, payload) {
      state.isVariantsListLoading = payload
    }
  },
  actions: {
    addHouse({state, commit}) {
      const houseForm = {
        house: state.houseForm.house.id,
        year: state.houseForm.year,
        kadastr: state.houseForm.kadastr,
      }
      return houseApi.addHouse(houseForm)
        .then(response => {
          if (response.status === 201) {
            commit('messages/addSuccess', 'Дом успешно добавлен', {root: true})
            return response
          }
          return false
        })
    },

    getHouseById({state, commit}) {
      return houseApi.getHouseById(state.houseForm.id).then(response => {
        commit('setHouseData', response)
        return response
      })
    },

    editHouse({state, commit}) {
      const houseForm = {
        ...state.houseForm,
        house: state.houseForm.house.id
      }
      let link = state.houseForm.links.find(i => i.rel === 'passport' && i.action === 'PUT')
      if (!link) {
        link = state.houseForm.links.find(i => i.rel === 'passport' && i.action === 'POST')
      }
      return houseApi.editHouse(link.href, houseForm)
        .then(response => {
          if (response.status === 200) {
            commit('messages/addSuccess', 'Дом успешно изменен', {root: true})
            return response
          }
          return false
        })
    },

    deleteHouse({commit}, link) {
      commit('setDeleteHouseLoading', true)
      return houseApi.deleteHouse(link)
        .then(response => {
          if (response.status === 204) {
            commit('messages/addSuccess', 'Дом успешно удален', {root: true})
            commit('setDeleteHouseLoading', false)
            return response
          }
        })
    },

    addressVariantClick({commit, dispatch}, payload) {
      commit('setAddress', payload)
      dispatch('addressValueChange', `${payload.value} `)
      return addressApi.hasHouseInAddress(payload.sign)
        .then(response => commit('setHouseInAddressExists', response))
    },

    addressValueChange({commit, getters}, payload) {
      if (payload === '') {
        commit('clearHouseData')
      } else if (getters.hasHouseData) {
        commit('clearHouseDataWithoutAddress')
      } else {
        commit('setAddressValue', payload)
        commit('setVariantsListLoading', true)
        return addressApi.getAddressVariants(payload)
          .then(response => {
            commit('setVariantsListLoading', false)
            commit('setVariantsList', response)
            return response
          })
      }

    },

    getHouseInfo({commit}, payload) {
      return addressApi.getHouseInfo(payload)
        .then(response => commit('setHouseData', {house: response}))
        .catch(() =>
          commit(
            'messages/addError',
            'Ошибка работы с сервисом ahunter, недостаточно средств на счете или неверный токен',
            {root: true}
          )
        )
    }

  }
}
